module.exports = __webpack_public_path__ + "static/media/grid.ed0ec5b8.svg";